import script from "./ArchivedDevices.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArchivedDevices.vue?vue&type=script&setup=true&lang=ts"

import "./ArchivedDevices.vue?vue&type=style&index=0&id=24b99bbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b99bbe"]])

export default __exports__